import { apiEndpoints } from './ApiEndpoints';
import { ApplicationConfig } from './Configuration.types';
import localConfig from '../config.local.json';
import productionConfig from '../config.production.json';
import testingConfig from '../config.testing.json';
import testingDiRootsConfig from '../config.testing.diroots.json';
import developDiRootsConfig from '../config.develop.diroots.json';

const environment = process.env.REACT_APP_ENV ?? 'testing';
let configFile =
environment === 'local'
    ? localConfig
    : environment === 'production'
    ? productionConfig
    : environment === 'testing.diroots'
    ? testingDiRootsConfig
    : environment === 'develop.diroots'
    ? developDiRootsConfig
    : testingConfig;
export const configSettings: ApplicationConfig = {
  api: { ...configFile.api, endpoints: apiEndpoints },
  authentication: configFile.authentication,
  diStellar: configFile.diStellar,
  minFileSize: 0,
  maxFileSize: 524288000, // as bytes - 500MB
};
